import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import { LOCAL_BUSINESS } from "@/lib/structured-data";

export const Route = createFileRoute("/reviews")({
  head: () => {
    const base = seo({
      title: "Reviews",
      description:
        "Google reviews for SeaClay Roofing & Spray Foam Insulation in Prairie Farm, WI. Trusted across Northwest Wisconsin.",
      path: "/reviews",
    });
    return {
      ...base,
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "RoofingContractor",
            "@id": LOCAL_BUSINESS["@id"],
            name: LOCAL_BUSINESS.name,
            review: [
              {
                "@type": "Review",
                author: { "@type": "Person", name: "Tessa Feeney" },
                reviewBody:
                  "Gary and crew have done a few projects around the farm and have always been top notch! He is prompt at getting back to you with estimates, timely at getting the job done, knowledgeable, professional, and cleans up the site when done.",
                reviewRating: { "@type": "Rating", ratingValue: 5, bestRating: 5 },
              },
              {
                "@type": "Review",
                author: { "@type": "Person", name: "Dave Nedland" },
                reviewBody:
                  "I have had SeaClay spray foam several new building project over the years. Large and small and could not be any happier of the work they have done.",
                reviewRating: { "@type": "Rating", ratingValue: 5, bestRating: 5 },
              },
              {
                "@type": "Review",
                author: { "@type": "Person", name: "Jim Andersen" },
                reviewBody:
                  "I have used SeaClay Roofing and Spray Foam for several projects over the years and they have always been professional, fair priced and do a great job with spray foam!",
                reviewRating: { "@type": "Rating", ratingValue: 5, bestRating: 5 },
              },
            ],
          }),
        },
      ],
    };
  },
});
